import { RouterModule, Routes } from '@angular/router';
import { canMatchLicenseGuard, goToAppGuard } from '@cfp/core';
import { AppComponent } from './app.component';

export const routes: Routes = [
  { path: '', component: AppComponent, canActivate: [goToAppGuard] },
  {
    path: 'energy',
    loadChildren: () =>
      import(
        /* webpackChunkName: "energy" */
        '@cfp/features/energy-routing'
      ).then((m) => m.EnergyRoutingModule)
  },
  {
    path: 'relation-management',
    loadChildren: () =>
      import(
        /* webpackChunkName: "relation-management" */
        '@cfp/features/relation-management'
      ).then((m) => m.RelationManagementModule)
  },
  {
    path: 'roadmap',
    loadChildren: () =>
      import(
        /* webpackChunkName: "roadmap" */
        '@cfp/domains/roadmap'
      ).then((m) => m.RoadmapModuleWithRouting)
  },
  {
    path: 'report',
    loadChildren: () =>
      import(
        /* webpackChunkName: "report" */
        '@cfp/features-shared/reports/report'
      ).then((m) => m.ReportModuleWithRouting)
  },
  {
    path: 'report-plus',
    loadChildren: () =>
      import(
        /* webpackChunkName: "report-plus" */
        '@cfp/features-shared/reports/report-plus'
      ).then((m) => m.ReportPlusModuleWithRouting)
  },
  {
    path: 'informatieplicht',
    loadChildren: () =>
      import(
        /* webpackChunkName: "informatieplicht" */
        '@cfp/features/informatieplicht'
      ).then((m) => m.InformatieplichtModuleWithRouting)
  },
  {
    path: 'compliance',
    loadChildren: () =>
      import(
        /* webpackChunkName: "compliance" */
        '@cfp/features/compliance'
      ).then((m) => m.ComplianceModuleWithRouting)
  },
  {
    path: 'climate-risk',
    data: { license: 'climate_risk' },
    canMatch: [canMatchLicenseGuard],
    loadChildren: () =>
      import(
        /* webpackChunkName: "climate-risk" */
        '@cfp/features/climate-risk'
      ).then((m) => m.ClimateRiskModuleWithRouting)
  },
  {
    path: 'dupa',
    data: { license: 'dupa' },
    canMatch: [canMatchLicenseGuard],
    loadChildren: () =>
      import(
        /* webpackChunkName: "dupa" */
        '@cfp/features/dupa/dupa.module'
      ).then((m) => m.DuPaModuleWithRouting)
  },
  {
    path: 'dumava',
    data: { license: 'dumava' },
    canMatch: [canMatchLicenseGuard],
    loadChildren: () =>
      import(
        /* webpackChunkName: "dumava" */
        '@cfp/features/dumava/dumava-module'
      ).then((m) => m.DumavaModuleWithRouting)
  },
  {
    path: 'crrem',
    data: { license: 'crrem_advanced' },
    canMatch: [canMatchLicenseGuard],
    loadChildren: () =>
      import(
        /* webpackChunkName: "crrem-advanced" */
        '@cfp/features/crrem-advanced'
      ).then((m) => m.CrremAdvancedModule)
  },
  {
    path: 'subsidy',
    data: { license: 'subsidy' },
    canMatch: [canMatchLicenseGuard],
    loadChildren: () =>
      import(
        /* webpackChunkName: "subsidy" */
        '@cfp/features-shared/subsidy'
      ).then((m) => m.SubsidyModule)
  },
  {
    path: 'public/buildings/:publicSharedId',
    redirectTo: 'report/public/buildings/:publicSharedId'
  },
  {
    path: 'public/buildings/:publicSharedId/roadmap',
    redirectTo: 'roadmap/public/buildings/:publicSharedId'
  },
  {
    path: 'energy/:portfolioId/roadmap',
    redirectTo: 'roadmap/:portfolioId'
  },
  {
    path: 'energy/:portfolioId/buildings/:buildingId/roadmap',
    redirectTo: 'roadmap/:portfolioId/buildings/:buildingId'
  },
  { path: '404-not-found', loadComponent: () => import('@cfp/shared/auth').then((m) => m.NotFoundPage) },
  { path: '**', redirectTo: '404-not-found' } // Always last
];

export const AppRouting = RouterModule.forRoot(routes, {});
